import { Container, Row, Col, Card } from 'react-bootstrap';
import '../Assets/Css/kng.css';
import aboutkng1 from '../Assets/Images/aboutkng1.png'
import React from 'react';
import { FaLeaf, FaSeedling, FaTree, FaRecycle, FaUsers, FaGlobeAsia } from 'react-icons/fa';
import { FaRoad, FaTint, FaHome, FaIndustry, FaUniversity } from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules'
import Landscap from '../Assets/Images/landscap.png';
import Highway from '../Assets/Images/highway.png';
import Garden from '../Assets/Images/garden.png';
import Office from '../Assets/Images/office.png';
import Tree from '../Assets/Images/tree.png';
import Irrigation from '../Assets/Images/irrigation.png';
import Residential from '../Assets/Images/residential.png';
import Commercial from '../Assets/Images/commercial.png';
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
 import clgimg from '../Assets/Images/college-landscape.jpg';
import contactimg from '../Assets/Images/contactimage.png';
import highway from '../Assets/Images/highway-plantation.jpg';

import avenueImg1 from '../Assets/Images/Avenue1.png';
import avenueImg2 from '../Assets/Images/Avenue2.png';
import avenueImg3 from '../Assets/Images/Avenue3.png';
import avenueImg4 from '../Assets/Images/Avenue4.png';
import avenueImg5 from '../Assets/Images/Avenue5.png';
import avenueImg6 from '../Assets/Images/Avenue6.png';
import avenueImg7 from '../Assets/Images/Avenue7.png';
import avenueImg8 from '../Assets/Images/Avenue8.png';

import landscapingImg1 from '../Assets/Images/land1.jpg';
import landscapingImg2 from '../Assets/Images/land2.jpg';
import landscapingImg3 from '../Assets/Images/land3.jpg';
import landscapingImg4 from '../Assets/Images/land4.jpg';
import landscapingImg5 from '../Assets/Images/land5.jpg';
import landscapingImg6 from '../Assets/Images/land6.jpg';

import nurseryImg1 from '../Assets/Images/nursery1.jpg';
import nurseryImg2 from '../Assets/Images/nursery2.jpg';
import nurseryImg3 from '../Assets/Images/nursery3.jpg';
import nurseryImg4 from '../Assets/Images/nursery4.jpg';
import nurseryImg5 from '../Assets/Images/nursery5.jpg';
import {  FaChair, FaCheckCircle, FaFlower, FaTools } from 'react-icons/fa';
import { GiFlowerEmblem } from 'react-icons/gi';

export default function KNGPage() {

 const features = [
  {
    id: 1,
    icon: <FaLeaf />,
    title: "Eco-Friendly Practices",
    description: "We use sustainable landscaping techniques with indigenous, water-wise plants to ensure low-maintenance, eco-conscious green spaces."
  },
  {
    id: 2,
    icon: <FaSeedling />,
    title: "50+ Years of Expertise",
    description: "Backed by decades of horticultural experience, our team delivers landscapes that are both beautiful and environmentally sound."
  },
  {
    id: 3,
    icon: <FaTree />,
    title: "Rich Plant Inventory",
    description: "With over 60% avenue trees and 40% ornamental and nursery plants, we support projects of every scale, from highways to home gardens."
  },
  {
    id: 4,
    icon: <FaRecycle />,
    title: "Sustainable Project Design",
    description: "Our designs incorporate rainwater harvesting, drip irrigation, native species, and organic practices for long-term sustainability."
  },
  {
    id: 5,
    icon: <FaUsers />,
    title: "Skilled Professional Team",
    description: "Our 50+ trained staff include expert horticulturists and landscapers who follow strict safety and quality practices."
    
  },
  {
    id: 6,
    icon: <FaGlobeAsia />,
    title: "Proven Project Impact",
    description: "From college campuses to 10,000-acre farms in Ethiopia, our work enhances beauty, boosts biodiversity, and delivers global value."
  }
];

const services = [
  {
    title: 'Landscape Management',
    icon: <FaLeaf size={30} className="text-success mb-3" />,
    description:
      'Comprehensive care for your spaces. Our professional team offers ongoing maintenance including pruning, weeding, fertilization, and pest control to ensure your landscape thrives year-round.',
    image: Landscap,
  },
  {
    title: 'Highway & Avenue Landscaping',
    icon: <FaRoad size={30} className="text-success mb-3" />,
    description:
      'We specialize in creating green highways and avenues, planting region-specific trees with expert care—from soil prep to irrigation—to boost beauty, sustainability, and roadside health.',
    image: Highway,
  },
   {
    title: 'Commercial & Industrial Facilities',
    icon: <FaIndustry size={30} className="text-success mb-3" />,
    description:
      'Professional landscaping solutions for businesses. Our services include site preparation, landscaping installation, maintenance, and tree care to enhance the value of your commercial property.',
    image: Commercial,
  },

  {
    title: 'Office Parks & Educational Institutions',
    icon: <FaUniversity size={30} className="text-success mb-3" />,
    description:
      'Creating inviting and functional outdoor spaces. We specialize in designing and maintaining landscapes that promote employee and student well-being.',
    image: Office,
  },
     {
    title: 'Residential Estates',
    icon: <FaHome size={30} className="text-success mb-3" />,
    description:
      'Our services include garden design, landscaping installation, maintenance, and tree care to create a beautiful and welcoming outdoor environment for residents.',
    image: Residential,
  },
    {
    title: 'Irrigation Maintenance',
    icon: <FaTint size={30} className="text-success mb-3" />,
    description:
      'Efficient and sustainable watering solutions. We offer regular maintenance, repairs, and upgrades to your irrigation system, ensuring healthy plant growth.',
    image: Irrigation,
  },

  {
    title: 'Tree Felling & Trimming',
    icon: <FaTree size={30} className="text-success mb-3" />,
    description:
      'Safe and efficient tree care. Our arborists provide expert tree removal and pruning services, ensuring the health and safety of your property and surrounding areas.',
    image: Tree,
  },

 
    {
    title: 'Garden Design & Horticulturist',
    icon: <FaSeedling size={30} className="text-success mb-3" />,
    description:
      'Our horticulturists design and plan gardens tailored to your specific needs, incorporating plants and hardscape elements to enhance your property’s beauty and functionality.',
    image: Garden,
  },
 
];

const avenuePlants = [
  { name: 'Mango', botanical: 'Mangifera indica', notes: 'A fruit-bearing, shade-providing avenue tree commonly used for roadside and boulevard planting.' },
  { name: 'Gulmohar', botanical: 'Delonix regia', notes: 'A fast-growing tree with bright red-orange flowers, ideal for creating a flowering canopy in large spaces.' },
  { name: 'Gur Malo', botanical: 'Cassia grandis (or similar)', notes: 'A large, seasonal flowering tree with pink blooms, suitable for parks and highways.' },
  { name: 'Kachnar', botanical: 'Bauhinia variegata', notes: 'An indigenous tree with pink and white blossoms, known for its ornamental and medicinal value.' },
  { name: 'Sapt Pati', botanical: 'Alstonia scholaris', notes: 'A tall, fragrant tree that purifies urban air and thrives in institutional landscapes.' },
  { name: 'Kashid', botanical: 'Cassia siamea / nodosa', notes: 'A tough, low-maintenance tree ideal for roadside planting and shade.' },
  { name: 'Saggaro', botanical: 'Local name; native allocation', notes: 'A multi-purpose native utility tree suited for large-scale ecological plantations.' },
  { name: 'Peepal', botanical: 'Ficus religiosa', notes: 'A sacred, long-living shade tree found in temples, streets, and public gardens.' },
  { name: 'Banyan', botanical: 'Ficus benghalensis', notes: 'A majestic, wide-canopy tree used in focal landscape areas and community spaces.' },
  { name: 'Asopalav', botanical: 'Polyalthia longifolia', notes: 'A popular, tall and narrow tree for avenues and noise pollution barriers.' },
  { name: 'Jamun', botanical: 'Syzygium cumini', notes: 'A fruit-bearing and shade-providing tree used in urban and highway landscaping.' },
  { name: 'Karinji', botanical: 'Wrightia tinctoria (likely)', notes: 'An adaptable native tree ideal for dry areas and low-maintenance landscapes.' },
  { name: 'Pongamia', botanical: 'Pongamia pinnata', notes: 'A nitrogen-fixing tree great for roadsides, providing shade and biofuel potential.' },
  { name: 'Indian Cork', botanical: 'Millingtonia hortensis', notes: 'A tall, fragrant flowering tree, commonly used in fragrant gardens and roadsides.' },
  { name: 'Neem', botanical: 'Azadirachta indica', notes: 'A medicinal, pest-resistant native species widely used in eco-landscaping.' },
  { name: 'Terminalia', botanical: 'Terminalia arjuna / catappa', notes: 'A large-leaf avenue tree used for streetscapes and waterbody embankments.' },
];

const landscapingPlants = [
  { name: 'Bougainvillea', botanical: 'Bougainvillea spp.', notes: 'Vibrant climbing shrub ideal for fences, trellises, and wall adornment.' },
  { name: 'Champa (Frangipani)', botanical: 'Plumeria spp.', notes: 'Fragrant flowering tree used in temples, gardens, and tropical designs.' },
  { name: 'Mehendi', botanical: 'Lawsonia inermis', notes: 'Used for hedges and aromatic purposes, also valued for its medicinal leaves.' },
  { name: 'Ticoma', botanical: 'Tecoma stans', notes: 'A bright yellow-flowering shrub ideal for driveways, roadsides, and highlights.' },
  { name: 'Hibiscus', botanical: 'Hibiscus rosa-sinensis', notes: 'Commonly used in flowering beds; attracts pollinators and adds bold color.' },
  { name: 'Ixora', botanical: 'Ixora coccinea', notes: 'Compact shrub with clusters of flowers, perfect for borders and tropical gardens.' },
  { name: 'Oleander', botanical: 'Nerium oleander', notes: 'Hardy, drought-tolerant shrub used as screen or flowering hedge in hot climates.' },
  { name: 'Duranta', botanical: 'Duranta erecta', notes: 'Ornamental plant for hedges and massing, valued for purple flowers and berries.' },
  { name: 'Native Grasses', botanical: 'Vetiver, Cymbopogon', notes: 'Soil stabilizers and fragrant species used for erosion control and aesthetics.' },
  { name: 'Plumbago', botanical: 'Plumbago auriculata', notes: 'A soft, flowering groundcover suited for garden edges and walkways.' },
];



const nurseryPlants = [
  { name: 'Areca Palm', notes: 'A popular indoor shade plant that improves air quality and adds lush greenery to interiors.' },
  { name: 'Tulsi', notes: 'An essential kitchen garden herb with medicinal value and religious significance in Indian households.' },
  { name: 'Crotons', notes: 'Bright ornamental foliage plant, perfect for balconies, patios, and indoor decoration.' },
  { name: 'Petunia', notes: 'A colorful flower used in hanging baskets and containers for instant visual impact.' },
  { name: 'Dracaena', notes: 'Low-light tolerant indoor foliage plant with air-purifying properties.' },
  { name: 'Money Plant', notes: 'Easy-to-grow vine used in pots or bottles, believed to bring prosperity indoors.' },
  { name: 'Aloe Vera', notes: 'A succulent medicinal plant used for skincare and health, great for kitchen corners.' },
  { name: 'Cordyline', notes: 'Vibrant foliage plant used in planters or borders, ideal for tropical landscaping.' },
  { name: 'Lemongrass', notes: 'Fragrant herb with culinary and mosquito-repellent uses; grows well in pots.' },
  { name: 'Portulaca', notes: 'Sun-loving succulent with colorful blooms, perfect for hanging baskets and rockeries.' },
];



const testimonials = [
    {
      message: "Their steel structure expertise helped us complete our industrial facility ahead of schedule.",
      author: "Project Engineer",
    },
    {
      message: "Professional team, accurate fabrication, and flawless erection. Highly recommended.",
      author: "Structural Consultant",
    },
    {
      message: "Our warehouse structure was installed with precision and safety top of mind.",
      author: "Site Manager",
    },
  ];

  return (
    <div className="mainnav min-vh-100">
     {/* Hero Section */}
      <section className="hero-section6">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in"> Kannan Nursery Gardens</h1>
          <p data-aos="zoom-in" data-aos-delay="100"> Nurturing Nature with Excellence Since 1990</p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" >Get in Touch</a>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-us py-5">
        <Container>
         
          <Row className="">
            <Col
  md={6}
  className="d-flex justify-content-center align-items-center"
>
  <img
    src={aboutkng1}
    alt="About Security Services"
    className="img-fluid aboutsecimg rounded shadow mb-3"
    data-aos="zoom-in" data-aos-delay="100"
  />
</Col><Col md={6}>
  <h2 className="page-title text-center" data-aos="fade-up">Overview</h2>
  <p data-aos="zoom-in" data-aos-delay="100">
    Established in 1990 as a family-run business, <strong>Kannan Nursery Gardens</strong> has redefined the landscaping industry. We offer tailor-made solutions for commercial and residential landscape management, backed by more than 50 years of combined experience. Breathing new life into any landscape is what we are known for.
  </p>
  <p data-aos="zoom-in" data-aos-delay="100">
    As professional landscapers, we understand the impact and impression that residential, commercial, public, or industrial gardens can have on the perceived value and quality of living. Landscaping goes beyond adding fragrant flowers and water features; it’s about creating an authentic experience that enchants visitors and complements the surrounding aesthetic and environment.
  </p>
  <p data-aos="zoom-in" data-aos-delay="100">
    Our team includes over 50 hand-picked, highly trained staff and professional landscapers capable of creating, revamping, and maintaining landscapes with excellence. With qualified horticulturists on board, we ensure the use of the best environmental practices. Health and safety are integral to our operations, guided by a team of experts to safeguard both people and the environment.
  </p>
  <p data-aos="zoom-in" data-aos-delay="100">
    <em>“We believe in looking after the environment—by using environmentally sustainable practices and by planting indigenous as well as water-wise plants as much as possible.”</em>
  </p>
</Col>
 </Row>
        </Container>
      </section>

{/* Why Choose Us Section */}
<section>
  <h2 className="page-title text-center" data-aos="fade-up">Why Choose Us</h2>
  <section className="why-choose-us-bg6 py-4 bg-light">
    <Container>
      <Row className="text-center">
        {features.map(({ id, icon, title, description }) => (
          <Col key={id} md={4} className="mb-4">
            <Card className="feature-card1 h-100 p-4 shadow-sm" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box mb-3 display-5 text-success">{icon}</div>
              <h5 className="choosetitle fw-bold">{title}</h5>
              <p className="mt-2">{description}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
</section>


<section className="py-5" style={{ backgroundColor: '#f9fefe' }}>
  <Container>
    <h2 className="page-title text-center" data-aos="fade-up">Inventory Summary</h2>

<Row className="mb-5">
  <Col md={{ span: 10, offset: 1 }}>
    <div
      className="bg-white p-4 rounded shadow-sm"
      style={{
        borderLeft: '5px solid #018080',
        backgroundColor: '#fdfdfd',
      }}
      data-aos="zoom-in"
    >
      <p className="text-muted text-center mb-0" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
        The inventory presented by <strong style={{ color: '#018080' }}>Karthik Nursery Gardens</strong> is curated to support a wide spectrum of landscaping needs—
        ranging from residential and institutional developments to large-scale government and commercial projects.
        The collection is strategically maintained with <strong>60%</strong> dedicated to avenue plantations and <strong>40%</strong> to landscaping and nursery varieties.
        Notably, over <strong>80%</strong> of the species are indigenous, reinforcing our commitment to ecological balance,
        native biodiversity, and sustainable green development.
      </p>
    </div>
  </Col>
</Row>

    {/* A. Avenue Plants */}
    <h4 className="text-center fw-bold mb-4" style={{ color: '#018080'}}>A. Avenue Plants (60%)</h4>
    <Row className="mb-5">
      <Col md={6} className="text-center mb-3">
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 3000 }}
          loop={true}
          className="shadow rounded"
        >
          {[avenueImg1, avenueImg2, avenueImg3, avenueImg4, avenueImg5, avenueImg6, avenueImg7, avenueImg8].map((img, index) => (
            <SwiperSlide key={index}>
              <img
                src={img}
                alt={`Avenue Plant ${index + 1}`}
                className="img-fluid rounded"
                style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Col>
      <Col md={6}>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          autoplay={{ delay: 3000 }}
        >
          {avenuePlants.map((plant, index) => (
            <SwiperSlide key={index}>
              <div className="p-4 bg-white shadow-sm rounded border">
                <h5 className="fw-bold" style={{ color: '#018080' }}>{plant.name}</h5>
                <p><strong>Botanical:</strong> <em>{plant.botanical}</em></p>
                <p className="text-muted">{plant.notes}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Col>
    </Row>

    {/* B. Landscaping & Nursery Plants */}
    <h4 className="text-center fw-bold mb-4" style={{ color: '#018080' }}>B. Landscaping & Nursery Plants (25%)</h4>
    <Row className="mb-5">
      <Col md={6} className="text-center mb-3">
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 3000 }}
          loop={true}
          className="shadow rounded"
        >
          {[landscapingImg1, landscapingImg2, landscapingImg3, landscapingImg4, landscapingImg5, landscapingImg6].map((img, index) => (
            <SwiperSlide key={index}>
              <img
                src={img}
                alt={`Landscaping Plant ${index + 1}`}
                className="img-fluid rounded"
                style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Col>
      <Col md={6}>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          autoplay={{ delay: 3000 }}
        >
          {landscapingPlants.map((plant, index) => (
            <SwiperSlide key={index}>
              <div className="p-4 bg-white shadow-sm rounded border">
                <h5 className="fw-bold" style={{ color: '#018080' }}>{plant.name}</h5>
                <p><strong>Botanical:</strong> <em>{plant.botanical}</em></p>
                <p className="text-muted">{plant.notes}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Col>
    </Row>

    {/* C. Nursery / Potted Plants */}
    <h4 className="text-center fw-bold mb-4" style={{ color: '#018080' }}>C. Nursery / Potted Plants (15%)</h4>
    <Row>
      <Col md={6} className="text-center mb-3">
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 3000 }}
          loop={true}
          className="shadow rounded"
        >
          {[nurseryImg1, nurseryImg2, nurseryImg3, nurseryImg4, nurseryImg5].map((img, index) => (
            <SwiperSlide key={index}>
              <img
                src={img}
                alt={`Nursery Plant ${index + 1}`}
                className="img-fluid rounded"
                style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Col>
      <Col md={6}>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          autoplay={{ delay: 3000 }}
        >
          {nurseryPlants.map((plant, index) => (
            <SwiperSlide key={index}>
              <div className="p-4 bg-white shadow-sm rounded border">
                <h5 className="fw-bold" style={{ color: '#018080' }}>{plant.name}</h5>
                <p className="text-muted">{plant.notes}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Col>
    </Row>
  </Container>
</section>
   <section className="services-content py-5 bg-light">
          <Container>
            <h2 className="page-title text-center mb-4" data-aos="fade-up">Our Nursery & Landscaping Services</h2>
       <Row>
  {services.map((service, index) => (
    <Col md={4} sm={12} className="mb-4" key={index}>
      <Card className="h-100 border-0 hover-shadow" data-aos="zoom-in" data-aos-delay="100">
        <Card.Img variant="top" src={service.image} alt={service.title} className="service-image" />
        <Card.Body className="text-center">
  {service.icon} {/* This is the key line to render the icon */}
  <Card.Title style={{ color: '#008080', textAlign: 'center' }}>{service.title}</Card.Title>
  <Card.Text>{service.description}</Card.Text>
</Card.Body>

      </Card>
    </Col>
  ))}
</Row>
 </Container>
    </section>
</section>
<section style={{ backgroundColor: '#f9fefe', padding: '60px 0' }}>
  <Container>
    <h2 className="page-title text-center mb-4" data-aos="fade-up">Project Showcase</h2>

    {/* Engineering College Project */}
    <Card className="mb-5 shadow-sm border-0" data-aos="fade-up">
      <Card.Body>
        <Row>
          <Col md={6} className="mb-4 mb-md-0">
        <h3 className="fw-bold" style={{ color: '#018080' }}>
  Landscaping Project at Leading Engineering College, Coimbatore
</h3>

            <p>
              <strong>Goal:</strong> Transform the campus into a sustainable, welcoming, and inspiring environment for students, faculty, and visitors.
            </p>

            <h6 className="text-success fw-bold">Key Deliverables:</h6>
            <ul className="ps-3">
              <li><FaLeaf className="text-success me-2" />Thematic landscape zones – meditation garden, floral walkways, vertical gardens</li>
              <li><FaTint className="text-info me-2" />Rainwater harvesting pits and irrigation channels</li>
              <li><FaChair className="text-secondary me-2" />Seating spaces with pergolas and shade plants</li>
              <li><FaTools className="text-warning me-2" />Installation of green signage and eco-awareness boards</li>
            </ul>

            <h6 className="text-success fw-bold">Plant Selection:</h6>
            <ul className="ps-3">
              <li>Fragrant plants: Jasmine, Gardenia</li>
              <li>Flowering plants: Marigold, Cosmos, Zinnia</li>
              <li>Shady trees: Neem, Pongamia, Ashoka</li>
            </ul>

            <h6 className="text-success fw-bold">Project Outcomes:</h6>
            <ul className="ps-3">
              <li><FaCheckCircle className="text-success me-2" />Increased aesthetic and green cover by 40%</li>
              <li><FaCheckCircle className="text-success me-2" />Rainwater runoff reduced by 30%</li>
              <li><FaCheckCircle className="text-success me-2" />Improved well-being and mindfulness zones for students</li>
            </ul>
          </Col>
          <Col md={6}>
            <img src={clgimg} alt="College Landscaping" className="img-fluid rounded shadow"
  style={{ marginTop: '110px', height: '300px', objectFit: 'cover' }}
/>
          </Col>
        </Row>
      </Card.Body>
    </Card>

    {/* Highway Kerb Plantation Project */}
    <Card className="shadow-sm border-0" data-aos="fade-up">
      <Card.Body>
        <Row>
          <Col md={6} className="mb-4 mb-md-0">
         <h3 className="fw-bold" style={{ color: '#018080' }}>
  Kerb Plantation for Highway Project (Govt. Initiative)
</h3>

            <p>
              <strong>Scope:</strong> Execute a highway greening plan under government beautification and sustainability mission. Project extended over a 10 km stretch.
            </p>

            <h6 className="text-success fw-bold">Implementation Highlights:</h6>
            <ul className="ps-3">
              <li><GiFlowerEmblem className="text-danger me-2" />Plant Selection: Bougainvillea, Hibiscus, Jasmine, Ixora, Cassia Fistula</li>
              <li><FaTint className="text-info me-2" />Smart Drip Irrigation: solar-powered system with water-saving nozzles</li>
              <li><FaTools className="text-secondary me-2" />Routine Maintenance: bio-manure usage, pruning cycles, pest management</li>
              <li><FaLeaf className="text-success me-2" />Use of native drought-resistant plants to ensure low maintenance</li>
            </ul>

            <h6 className="text-success fw-bold">Safety & Design Considerations:</h6>
            <ul className="ps-3">
              <li>Non-obstructive plant height for traffic visibility</li>
              <li>Strategic placement to avoid signboard or light pole interference</li>
              <li>Protective barriers for plant zones near turning points</li>
            </ul>

            <h6 className="text-success fw-bold">Outcomes:</h6>
            <ul className="ps-3">
              <li><FaCheckCircle className="text-success me-2" />Aesthetic improvement of roadside zones</li>
              <li><FaCheckCircle className="text-success me-2" />Helped regulate ambient temperatures by 1.5°C</li>
              <li><FaCheckCircle className="text-success me-2" />Generated 15+ local jobs for maintenance and nursery supply</li>
            </ul>
          </Col>
          <Col md={6}>
           <img
  src={highway}
  alt="Highway Plantation"
  className="img-fluid rounded shadow"
  style={{ marginTop: '110px', height: '300px', objectFit: 'cover' }}
/>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </Container>
</section>
{/* Contact CTA Section */}
{/* <section className="contact-cta py-4 text-center bg-success bg-opacity-10">
  <Container>
    <Row className="align-items-center">
      <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in">
        <h2 className="text-success fw-bold">Looking for Expert Nursery & Landscaping Services?</h2>
        <p className="lead text-dark">
          From garden design to highway landscaping, our team is ready to bring your green vision to life.
        </p>
        <a href="/contact" className="btn-get">Get in Touch</a>
      </Col>

      <Col md={6}>
        <div className="d-flex justify-content-center">
        <img
  src={nurseryCtaImg1}
  alt="Nursery Landscaping Team"
  className="img-fluid rounded shadow"
  style={{ width: '100%', maxWidth: '400px', height: '300px '}}
  data-aos="zoom-in"
  data-aos-delay="100"
/>

        </div>
      </Col>
    </Row>
  </Container>
</section> */}
<section style={{ backgroundColor: '#f0fef8', padding: '60px 0' }}>
  <Container>
    <Row className="align-items-center">
      
      {/* Left Image */}
      <Col md={6} className="mb-4 mb-md-0">
      <img
  src={contactimg}
  alt="KNG Nursery"
  className="img-fluid rounded shadow"
  style={{ maxWidth: '100%', height: '300px', objectFit: 'cover' }}
/>

      </Col>

      {/* Right Contact Info */}
      <Col md={6}>
        <div className="px-md-4">
        <h2 className="fw-bold mb-4" style={{ color: '#fe8200' }}>
  Contact us for further inquiries
</h2>


          <div className="mb-4 d-flex align-items-start">
            <FaPhoneAlt className="text-success fs-4 me-3 mt-1" />
            <div>
              <div className="fw-bold">Mobile</div>
              <a href="tel:9952720172" className="text-dark text-decoration-none">9952720172</a>
            </div>
          </div>

          <div className="mb-4 d-flex align-items-start">
            <FaMapMarkerAlt className="text-success fs-4 me-3 mt-1" />
            <div>
              <div className="fw-bold">KANNAN NURSERY GARDEN</div>
              Santhur, Krishnagiri, Tamil Nadu
            </div>
          </div>

          <div className="d-flex align-items-start">
            <FaEnvelope className="text-success fs-4 me-3 mt-1" />
            <div>
              <div className="fw-bold">Email</div>
              <a href="mailto:karthikeshr22@gmail.com" className="text-dark text-decoration-none">karthikeshr22@gmail.com</a>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </Container>
</section>
      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-white">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up">Client Testimonials</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p >⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
     
    </div>
  );
}